module.exports = __webpack_public_path__ + "static/media/ic-users.840311a1.svg";